import { InjectionToken, StaticProvider } from '@angular/core';

import { BaseApiConfig, EndpointParserFn } from '../../models/base-api-config.model';

export type BlockedCreatorsApiConfig = BaseApiConfig<{
  blockCreator: string;
  listBlockedCreators: string;
  unblockCreator: EndpointParserFn;
}>;

export const BLOCKED_CREATORS_API_CONFIG = new InjectionToken<BlockedCreatorsApiConfig>('BLOCKED_CREATORS_API_CONFIG');

export const provideBlockedCreatorsApiConfig = (config: BlockedCreatorsApiConfig): StaticProvider => ({
  provide: BLOCKED_CREATORS_API_CONFIG,
  useValue: config,
});
